module.exports = __webpack_public_path__ + "static/media/12.4c45fc03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/12.jpg
// module id = 273
// module chunks = 0